<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/local"> Cadastro/Locais </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>

    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center" >
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="unidAdmAtivo" label="Unidade Administrativa"></v-checkbox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-checkbox v-model="localEntregaAtivo" label="Local De Entrega"></v-checkbox> 
          </v-col>
      </v-row>

      <v-row align="center">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Local *"
              v-model="descricao"
              :counter="200"
              :rules="[(v) => !!v || 'A descrição do local é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Obra nº *"
              v-model="numeroDoLocal"
              :counter="15"
              :rules="[(v) => !!v || 'O Número Do Local é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Contratante"
              v-model="contratante"
              :counter="200"
              required
            ></v-text-field>
          </v-col>
        </v-row>        
        <endereco ref="endereco" />
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <v-btn to="/local" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { cadastrarLocalAsync } from "../../../services/localService";
import Endereco from "../Endereco";
import { mapActions } from "vuex";
//import Local from "./Local";

export default {
  name: "criarLocais",
  data: () => ({
    overlay: false,
    valid: true,
    localEntregaAtivo: false,
    unidAdmAtivo: true,
    descricao: null,
    numeroDoLocal: null,
    contratante: null,
    idTipoLocais: null,
  }),
  methods: {
    ...mapActions("local", ["addLocal"]),
    async enviar()
    {
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      this.idTipoLocais = this.validaTipoLocais();

      if ((this.unidAdmAtivo === false) &&((this.localEntregaAtivo === false)))
      {
        this.$alert("Checkbox não preenchido", "Gentileza preencher o checkbox", "error");
        this.overlay = false;
      }
      else
      { if (this.$refs.form.validate() && enderecoValido) {
        this.overlay = true;
        const resposta = await cadastrarLocalAsync(
          this.descricao,
          this.idTipoLocais,
          this.contratante,
          this.numeroDoLocal,
          this.$refs.endereco.cep,
          this.$refs.endereco.logradouro,
          this.$refs.endereco.numero,
          this.$refs.endereco.complemento,
          this.$refs.endereco.bairro,
          this.$refs.endereco.cidade,
          this.$refs.endereco.uf
        );

        if (resposta && resposta.id) 
        {
          this.overlay = false;
          this.addLocal(this.mountObjLocal(resposta));
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/local");
        }
        else
        {
          this.overlay = false;
          this.$alert(resposta && resposta.message ? resposta.message : "", "Desculpe, falha na operação!", "error");
        }
      }
      }
    },
    mountObjLocal(localSalvo) {
      return {
        ...localSalvo,
        tipoLocal: this.getTipoLocal(this.idTipoLocais),
        enderecoCompleto: this.getEnderecoCompleto(),
      };
    },
    getTipoLocal(idTipoLocais) {
      if (idTipoLocais === 3) return "Unidade Administrativa/Local De Entrega";
      if (idTipoLocais === 2) return "Unidade Administrativa";
      if (idTipoLocais === 1) return "Local De Entrega";
      return "";
    },
    getEnderecoCompleto() {
      return [
        this.$refs.endereco.logradouro,
        this.$refs.endereco.numero,
        this.$refs.endereco.bairro,
        this.$refs.endereco.cidade,
        this.$refs.endereco.uf,
      ].filter(Boolean).join(", ");
    },
    validaTipoLocais() 
    {
      if ((this.unidAdmAtivo === true) &&((this.localEntregaAtivo === true)))
      {
        return 3;
      }
      else if ((this.unidAdmAtivo === true) &&((this.localEntregaAtivo === false)))
      {
        return 2;
      }
      else if ((this.unidAdmAtivo === false) &&((this.localEntregaAtivo === true)))
      {
        return 1;
      }
    },
    editaEndereco(index) {
      this.indexEdit = index;
      this.showModal = true;
    },
    findLocal(localId) {
      return this.locais.find((lc) => lc.id === localId);
    },
    update() {
      var endereco = this.enderecos.filter((e) => e.index === this.indexEdit);
      this.$refs.edit.updateObject2(endereco[0]);
    },
    atualizar: function (e) {
      var enderecoValido = this.$refs.edit.updateObjectEstate();
      if (!enderecoValido) {
        e.preventDefault();
      }
      this.enderecos[this.indexEdit].cep = this.$refs.edit.cep;
      this.enderecos[this.indexEdit].logradouro = this.$refs.edit.logradouro;
      this.enderecos[this.indexEdit].numero = this.$refs.edit.numero;
      this.enderecos[this.indexEdit].complemento = this.$refs.edit.complemento;
      this.enderecos[this.indexEdit].bairro = this.$refs.edit.bairro;
      this.enderecos[this.indexEdit].cidade = this.$refs.edit.cidade;
      this.enderecos[this.indexEdit].uf = this.$refs.edit.uf;
      this.showModal = false;
    },
  },
  components: {
    Endereco,
  },
};
</script>
